<button
  class="btn btn-dark back-to-top"
  (click)="scrollToTop()"
  *ngIf="showButton"
  title="Back to top"
  id="backToTop"
  aria-label="Back to top"
>
  <fa-icon [icon]="['far', 'chevron-up']"></fa-icon>
</button>
